import React from 'react';
import { Icon } from './Icon';

const SearchModeToggle = ({ searchMode, onModeChange, disabled = false }) => {
  return (
    <div className="mb-6">
      <label className="block text-sm font-semibold text-ink-muted mb-3">
        Search Mode
      </label>
      <div className="grid grid-cols-2 gap-4">
        {/* Fast Search */}
        <button
          type="button"
          onClick={() => onModeChange('fast')}
          disabled={disabled}
          className={`relative p-4 rounded-xl border transition-all ${
            searchMode === 'fast'
              ? 'border-blue-500 bg-blue-500/10 shadow-md'
              : 'border-line bg-surface hover:border-blue-500/40 hover:bg-muted'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${searchMode === 'fast' ? 'bg-blue-500/20 text-blue-300' : 'bg-subtle text-ink-subtle'}`}><Icon name="bolt" className="w-5 h-5" /></span>
            </div>
            <div className="flex-1 text-left">
              <h3 className="font-medium text-ink mb-1">
                Fast Search
              </h3>
              <p className="text-sm text-ink-muted">
                Quick results using keywords and AI matching.
                Best for high-volume screening.
              </p>
              <div className="mt-2 text-xs text-ink-subtle">
                • Matches exact skills and keywords<br/>
                • Filters by must-have requirements<br/>
                • Results in under 1 minute
              </div>
              <div className="mt-2 text-xs font-medium text-blue-400">
                Best for: Quick screening, bulk hiring, exact requirements
              </div>
            </div>
            {searchMode === 'fast' && (
              <div className="absolute top-2 right-2">
                <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-400 bg-accent-soft rounded-full">
                  Selected
                </span>
              </div>
            )}
          </div>
        </button>

        {/* Deep AI Search */}
        <button
          type="button"
          onClick={() => onModeChange('ai-native')}
          disabled={disabled}
          className={`relative p-4 rounded-xl border transition-all ${
            searchMode === 'ai-native'
              ? 'border-indigo-500 bg-indigo-500/10 shadow-md'
              : 'border-line bg-surface hover:border-indigo-500/40 hover:bg-muted'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${searchMode === 'ai-native' ? 'bg-indigo-500/20 text-indigo-300' : 'bg-subtle text-ink-subtle'}`}><Icon name="sparkles" className="w-5 h-5" /></span>
            </div>
            <div className="flex-1 text-left">
              <h3 className="font-medium text-ink mb-1">
                Deep AI Search
              </h3>
              <p className="text-sm text-ink-muted">
                AI reads each CV and explains why candidates match.
                Takes 2-3 minutes but worth it for key roles.
              </p>
              <div className="mt-2 text-xs text-ink-subtle">
                • Understands context, not just keywords<br/>
                • Explains why each candidate fits<br/>
                • Shows skill gaps and growth potential
              </div>
              <div className="mt-2 text-xs font-medium text-blue-400">
                Best for: Senior roles, complex JDs, final shortlists
              </div>
            </div>
            {searchMode === 'ai-native' && (
              <div className="absolute top-2 right-2">
                <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-300 bg-indigo-500/15 rounded-full">
                  Selected
                </span>
              </div>
            )}
          </div>
        </button>
      </div>

      {/* Simplified Guide */}
      <div className="mt-3 p-4 bg-muted rounded-lg border border-line">
        <div className="text-sm text-ink-muted">
          <span className="font-medium">💡 Quick guide:</span> Use
          <span className="text-blue-400 font-medium"> Fast Search </span>
          for most searches. Switch to
          <span className="text-blue-400 font-medium"> Deep AI </span>
          when you need detailed explanations or are making final decisions.
        </div>

        {/* Timing Indicator */}
        <div className="mt-3 pt-3 border-t border-line">
          <div className="flex items-center justify-between text-xs text-ink-subtle">
            <span>Expected time:</span>
            <span className={searchMode === 'fast' ? 'text-blue-400 font-medium' : 'text-blue-400 font-medium'}>
              {searchMode === 'fast' ? 'Under 1 minute' : '2-3 minutes'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchModeToggle;